import exportacaoRepository from './exportacaoRepositoryRepository'
import procedimentoConsolidadoRepository from './procedimentoConsolidadoRepository'
import procedimentoIndividualizadoRepository from './procedimentoIndividualizadoRepository'
import relatorioBpaConsolidadoRepository from './relatorioBpaConsolidadoRepository'
import relatorioBpaIndividualizadoRepository from './relatorioBpaIndividualizadoRepository'
import relatorioInconsistenciaRepository from './relatorioInconsistenciaRepository'
import relatorioQuantitativoProducaoRepository from './relatorioQuantitativoProducaoRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/bpa`

    return {
        exportacao: exportacaoRepository(baseUrl),
        procedimentoConsolidado: procedimentoConsolidadoRepository(baseUrl),
        procedimentoIndividualizado: procedimentoIndividualizadoRepository(baseUrl),
        relatorioBpaConsolidado: relatorioBpaConsolidadoRepository(baseUrl),
        relatorioBpaIndividualizado: relatorioBpaIndividualizadoRepository(baseUrl),
        relatorioInconsistencia: relatorioInconsistenciaRepository(baseUrl),
        relatorioQuantitativoProducao: relatorioQuantitativoProducaoRepository(baseUrl),
    }
}
